export default __webpack_public_path__ + "static/media/pink.084fdc43.svg";